/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import axios from 'axios';
import { Graphql } from '@common/graphql';
import { REJECTED_DOC_APPLICATION_SUBMIT } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';

export interface IRejectedDocumentsApplicationMethods extends IPluginMethodMap {
  rejectedDocumentsApplication(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class RejectedDocumentsApplicationService implements IAgentPlugin {
  readonly methods: IRejectedDocumentsApplicationMethods;

  constructor() {
    this.methods = {
      rejectedDocumentsApplication:
        this.rejectedDocumentsApplication.bind(this),
    };
  }
  format(data: any) {
    let _documents: any[] = [];
    console.log(`service args`, data);
    // workPermitConfig?.availableDocuments &&
    Object.entries(data).forEach((ele) => {
      if (
        data[ele[0]] &&
        Array.isArray(data[ele[0]]) &&
        data[ele[0]].length > 0
      ) {
        let _docs: any[] = [];
        console.log(`service args getDocuments #1`, data[ele[0]]);
        const ans = data[ele[0]];
        if (ans && Array.isArray(ans) && ans.length > 0) {
          ans.forEach((e) => {
            console.log('service args e', e);
            _docs.push({
              name:
                (e?.evidences &&
                  Array.isArray(e?.evidences) &&
                  e?.evidences[0]?.name) ||
                (e?.photo && Array.isArray(e?.photo) && e?.photo[0]?.name),
              type: e?.evidencetype,
              src:
                (e?.evidences &&
                  Array.isArray(e?.evidences) &&
                  e?.evidences[0]?.base64) ||
                (e?.photo && Array.isArray(e?.photo) && e?.photo[0]?.base64),
              fileType:
                (e?.evidences &&
                  Array.isArray(e?.evidences) &&
                  e?.evidences[0]?.type) ||
                (e?.photo && Array.isArray(e?.photo) && e?.photo[0]?.type),
            });
          });
        }
        // if (data[`expiry${ele[0]}`]) {
        //   //@ts-ignore
        //   res = { ...res, expiry: data[`expiry${ele[0]}`] };
        // }
        console.log(`workPermitApp service getDocuments #2`, _documents, _docs);
        _documents = [..._documents, ..._docs];
      }
    });
    console.log('service args documents', _documents);
    return { documents: _documents };
  }
  async rejectedDocumentsApplication(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    try {
      if (client) {
        console.log(client);
        const res = await client
          .mutation(
            REJECTED_DOC_APPLICATION_SUBMIT,

            {
              input: {
                ...this.format(args),
                applicationNo: args?.applicationNo,
              },
            }
          )
          .toPromise();
        console.log('resss->', res);
        if (res?.data?.reSubmitApplicationDoc) {
          return {
            data: res?.data?.reSubmitApplicationDoc,
          };
        }
        console.log('qqq err caught');
        throw res?.data?.errors?.[0];
      }
    } catch (err: any) {
      console.log('qqq err caught is ', err);
      throw err;
    }
  }
}
